(function () {
    var trainingCourses = {
        vPort: 'screen-md',
        isMobile: false,
        $courseAccordionControl: $('.training-courses .accordion-tabbed__control'),

        init: function () {
            trainingCourses.controls();
            trainingCourses.truncate($('.training-course__abstract'));
            trainingCourses.click(trainingCourses.$courseAccordionControl.first());
        },
        controls: function () {
            $(document).on(UX.trainingCourses.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                trainingCourses.isMobile = true;
                trainingCourses.truncate($('.training-course__abstract'));
            });

            $(document).on(UX.trainingCourses.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                trainingCourses.isMobile = false;
            });

            trainingCourses.$courseAccordionControl.click(function () {
                trainingCourses.click($(this));
            });
        },
        click: function ($this) {
            var content = null,
                $carousel = null;
            if ($this.closest('.accordion-vport--res').length === 0) {
                trainingCourses.$courseAccordionControl.removeClass('hover');
                $this.addClass('hover');

                content = $('#' + $this.attr('aria-controls')).html();
                $('.training-courses__view-box').empty();
                $(content).hide().appendTo('.training-courses__view-box').fadeIn(850);

                $carousel = $('.training-courses__view-box .owl-carousel');
                $carousel.owlCarousel(UX.slider.get.options($carousel, true));

                trainingCourses.truncate($('.training-courses__view-box .training-course__abstract'));
            }
        },
        truncate: function ($this) {
            if (trainingCourses.isMobile) {
                $this.not("[data-truncate='none']").truncate({
                    type: 'text',
                    position: 'end',
                    lines: 4,
                    seeMoreText: '',
                    seeLessText: '',
                    seeMoreHtml: '',
                    ellipsisChar: '&hellip;',
                    isMobile: true,
                    isSliding: false,
                });
            } else {
                $this.not("[data-truncate='none']").truncate({
                    type: 'text',
                    position: 'end',
                    lines: 6,
                    seeMoreText: '',
                    seeLessText: '',
                    seeMoreHtml: '',
                    ellipsisChar: '&hellip;',
                    isMobile: true,
                    isSliding: false,
                });
            }
        },
    };
    UX.trainingCourses = trainingCourses;
})();
